import * as React from "react";
import { useSelector } from "../../../../store";

import { Box, Typography } from "@mui/material";
import Logo from "../../../ui-components/Logo";
import trophyImgSrc from "../../../../assets/images/complete.png"

export default function Webomplete({
    onChangeWebStyleLayout = () => {}
}) {
	const clientState = useSelector((state) => state.client || {});
    const [learnerRedirectionURL, setLearnerRedirectionURL] = React.useState("");

    React.useEffect(() => {
        // change the layout
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: false,
                // justifyContent: "center",
            }
        });
    }, [onChangeWebStyleLayout]);

    React.useEffect(() => {
        const url = clientState?.details?.preferences?.learnerRedirectionURL || "";
        if (!url) {
            setLearnerRedirectionURL("");
            return;
        }
        setLearnerRedirectionURL(/^https?:\/\//i.test(url) ? url : `https://${url}`);
    }, [clientState]);

	return (
		<React.Fragment>
			<Box
				sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
				}}
			>
				{clientState?.details?.logo?.absolute ? (
                    <img
                        alt="logo"
                        src={clientState.details.logo.absolute}
                        style={{
                            maxWidth: "22rem",
                            maxHeight: "11rem",
                        }}
                    />
                ) : <Logo width="80px" />}
                
                <Box sx={{
                    textAlign: "center",
                    marginTop: "40px",
                }}>
                    <Typography component="h1"
                        sx={{
                            fontSize: "2.5em",
                            marginTop: "0px",
                            marginBottom: "10px",
                            textAlign: "center",
                            fontWeight: "bold",
                            "@media (max-width: 1024px), (max-height: 768px)": {
                                fontSize: "2em",
                            },
                            "@media (max-width: 800px), (max-height: 600px)": {
                                fontSize: "2em",
                            },
                        }}
                    >Language, Literacy & Numeracy Quiz Complete</Typography>
                </Box>
                <Box sx={{
                    marginTop: "40px",
                }}>
                    <Box component="img"
                        src={trophyImgSrc}
                        alt="Trophy Img"
                        sx={{
                            height: "100px"
                        }}
                    />
                </Box>
			</Box>
            <Box sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    textAlign: "center",
                }}>
                    <Typography component="a"
                        sx={{
                            cursor: "pointer",
                            display: "inline-block",
                            width: "180px",
                            height: "45px",
                            lineHeight: "2.4em",
                            backgroundColor: "#0e9595",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            borderBottom: "2px solid #0e9595",
                            textDecoration: "none",
                            boxSizing: "border-box",
                            paddingTop: "3px",
                            textAlign: "center",
                            "&:hover": {
                                backgroundColor: "none",
                                cursor: "pointer",
                            },
                        }}
                        href={
							learnerRedirectionURL ||
							"https://tlrg.com.au/"
						}
                    >
                        <Box component="span"
                            sx={{
                                fontWeight: "bold",
                                fontSize: "2em",
                                color: "white",
                                textAlign: "center",
                                "@media (max-width: 1024px), (max-height: 768px)": {
                                    fontSize: "1.5em",
                                },
                                "@media (max-width: 800px), (max-height: 600px)": {
                                    fontSize: "1.5em",
                                },
                            }}
                        >Exit</Box>
                    </Typography>
                </Box>
		</React.Fragment>
	);
}